<template>
  <el-container id="app">
    <router-view />
  </el-container>
</template>
<script>
export default {
  computed: {
    token() {
      return this.$store.getters.token
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
body{
  margin:0;
}
html,body{
  width: 100%;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
